/*
 * VatomInc. Copyright (c) 2022, all rights reserved.
 *
 * This source code is licensed under the license found in the LICENSE file in the root directory of this source tree.
 */

import MultiWebSockets from '../../../../client/manager/MultiWebSockets'
import Store from '../../../repo/Store'
import Client from '../../Client'

export default class VatomApi {
  static _instance: VatomApi

  client: Client
  store: Store
  webSockets: MultiWebSockets

  constructor(appID: string, server: string, websocketServer: string) {
    const store = new Store('native')
    store.appID = appID
    store.server = server || 'https://api.vi.vatom.network'
    store.websocketAddress = [websocketServer || 'wss://ws.vatominc.net']

    this.store = store
    this.client = new Client(store)

    // const userApi = new UserApi(this)
    this.webSockets = new MultiWebSockets(store, this.client)
    VatomApi._instance = this
  }

  static getInstance(appID: string, server: string, websocketServer: string) {
    return VatomApi._instance || new VatomApi(appID, server, websocketServer)
  }
}
